import t10 from "./images/photographyPage/t1/t10.jpg";
import t11 from "./images/photographyPage/t1/t11.jpg";
import t12 from "./images/photographyPage/t1/t12.jpg";
import t13 from "./images/photographyPage/t1/t13.jpg";
import t14 from "./images/photographyPage/t1/t14.jpg";
import t15 from "./images/photographyPage/t1/t15.jpg";

import t20 from "./images/photographyPage/t2/t20.jpg";
import t21 from "./images/photographyPage/t2/t21.jpg";
import t22 from "./images/photographyPage/t2/t22.jpg";
import t23 from "./images/photographyPage/t2/t23.jpg";
import t24 from "./images/photographyPage/t2/t24.jpg";
import t25 from "./images/photographyPage/t2/t25.jpg";

import t30 from "./images/photographyPage/t3/t30.jpg";
import t31 from "./images/photographyPage/t3/t31.jpg";
import t32 from "./images/photographyPage/t3/t32.jpg";
import t33 from "./images/photographyPage/t3/t33.jpg";
import t34 from "./images/photographyPage/t3/t34.jpg";
import t35 from "./images/photographyPage/t3/t35.jpg";

import t40 from "./images/photographyPage/t4/t40.jpg";
import t41 from "./images/photographyPage/t4/t41.jpg";
import t42 from "./images/photographyPage/t4/t42.jpg";
import t43 from "./images/photographyPage/t4/t43.jpg";
import t44 from "./images/photographyPage/t4/t44.jpg";
import t45 from "./images/photographyPage/t4/t45.jpg";

const photographyPageContent = [
  {
    topicNo: "t1",
    photographyTitle: "Children",
    imageArray: [t10, t11, t12, t13, t14, t15],
  },
  {
    topicNo: "t2",
    photographyTitle: "Victoria",
    imageArray: [t20, t21, t22, t23, t24, t25],
  },
  {
    topicNo: "t3",
    photographyTitle: "Steppe",
    imageArray: [t30, t31, t32, t33, t34, t35],
  },
  {
    topicNo: "t4",
    photographyTitle: "The world is too dark,Mom!",
    imageArray: [t40, t41, t42, t43, t44, t45],
  },
];

export default photographyPageContent;
